// @ts-strict-ignore
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { LabelIconData } from '../label-icon/label-icon.component.types';

@Component({
    selector: 'app-expansion-checkbox-panel',
    templateUrl: './expansion-checkbox-panel.component.html',
    styleUrls: ['./expansion-checkbox-panel.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ExpansionCheckboxPanelComponent {
  @Input() checkboxLabel: boolean;
  @Input() checkboxValue: boolean;
  @Input() labelIcon?: LabelIconData;
  @Input() style: { [klass: string]: any } = {};

  @Output() checkboxChange = new EventEmitter<boolean>();
  @Output() isExpanded = new EventEmitter<boolean>();

  onCheckboxEnter(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.checkboxChange.emit(!this.checkboxValue);
  }
}
